import { RootState } from '../../../../../init-store';
import { MAX_SHARING_ZOOM, MIN_SHARING_ZOOM } from './constants';
import type { SharingZoomState } from './slice';

export const selectSharingZoom = (state: RootState): SharingZoomState => state.call.sharingZoom;

export const selectZoomLevelPercent = (state: RootState): number => Math.round(state.call.sharingZoom.scale * 100);

export const selectCanZoomIn = (state: RootState): boolean => state.call.sharingZoom.scale < MAX_SHARING_ZOOM;

export const selectCanZoomOut = (state: RootState): boolean => state.call.sharingZoom.scale > MIN_SHARING_ZOOM;
